function Connect() {
  return (
    <footer className="contact" id="contact">
      <div className="contact-kicker">04 · Contact</div>
      <h2>Let’s keep in touch.</h2>
      <p>I’m always glad to meet thoughtful people working on hard problems.</p>
      <div className="contact-links">
        <a href="https://www.linkedin.com/in/edward-xing/" target="_blank" rel="noreferrer">LinkedIn <span>↗</span></a>
        <a href="https://github.com/exing1" target="_blank" rel="noreferrer">GitHub <span>↗</span></a>
        <a href="https://www.youtube.com/watch?v=UE9AvpJzG7E" target="_blank" rel="noreferrer">YouTube <span>↗</span></a>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} Edward Xing</span><span>Designed with restraint. Built with care.</span></div>
    </footer>
  );
}

export default Connect;
